<template>
  <div
    class="admin-page-header"
    :class="{ 'admin-page-header--compact': compact }"
  >
    <div class="admin-page-header__copy">
      <span
        v-if="eyebrow"
        class="admin-page-header__eyebrow"
      >{{ eyebrow }}</span>
      <h1 class="admin-page-header__title">
        {{ title }}
      </h1>
      <p
        v-if="description && showDescription"
        class="admin-page-header__description"
      >
        {{ description }}
      </p>
    </div>

    <div
      v-if="$slots.actions"
      class="admin-page-header__actions"
    >
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminPageHeader',
  props: {
    eyebrow: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    showDescription: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
